import { forceCollide } from 'd3-force';

// Replaces the previous repel force. After centering each community via the
// centroid force, compute the community radius as the distance from the
// virtual node to its furthest member node. A collision force using twice that
// radius is then applied between community nodes.
export default function communityRepelForce(strength = 1) {
  let nodes;
  const collide = forceCollide()
    .strength(Math.abs(strength))
    .radius((n) => n.__communityCollideRadius || 0);

  function force(alpha) {
    if (!nodes) return;

    // determine radius per community
    for (const n of nodes) {
      let max = 0;
      if (n.members) {
        for (const m of n.members) {
          const dx = (m.x || 0) - (n.x || 0);
          const dy = (m.y || 0) - (n.y || 0);
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist > max) max = dist;
        }
      }
      n.__communityCollideRadius = max * 2;
    }

    // rebuild quadtree with updated radii and apply collision
    collide.initialize(nodes);
    collide(alpha);
  }

  force.initialize = function (_) {
    nodes = _;
  };

  force.strength = function (_) {
    return arguments.length ? ((strength = +_), collide.strength(Math.abs(strength)), force) : strength;
  };

  return force;
}
